// extracted by mini-css-extract-plugin
module.exports = {"aboutStyles":"pages-about-styles__aboutStyles","background":"pages-about-styles__background"};